import { getTextWidth } from 'utils/miscUtil';
import { AnalyticsTabItem } from 'store/analytics/ui/analyticsUiTypes';

/**
 * Calculates inline width for the tab.
 */
export const calculateTabWidth = (tabName: string) => {
  return getTextWidth(tabName, '15px Open Sans') + 56;
};

/**
 * Calculates size for the whole scroll menu ( items including navigation arrows < & >)
 * @param items
 */
export const calculateAnalyticsScrollBarMenuWidth = (items: AnalyticsTabItem[]) => {
  let totalWidth = 0;
  items.forEach(item => {
    if (item.name !== undefined) {
      totalWidth += calculateTabWidth(item.name);
    }
  });

  // Padding for arrows
  totalWidth += 80;

  return totalWidth;
};

/**
 * Calculates offset for the dropdown based on menu width.
 * @param menuWidth
 */
export const calculateAnalyticsDropDownOffset = (menuWidth: number) => {
  if (menuWidth < 1024) {
    return -40;
  }

  if (menuWidth >= 1024 && menuWidth < 1280) {
    return -30;
  }

  return 0;
};
